<template>
    <div class="login">
        <div class="login--content">
            <img src="images/renova-logo.png" alt="RRENOVA" class="login--logo" width="220">
            <form action="" class="login--form">
                <div class="login--text-wrap">
                    <p>{{ $t('requestResetPasswordPage.description') }}</p>
                </div>
                <div class="login--input--wrap">
                    <label for="" class="login--label">{{ $t('requestResetPasswordPage.form.password') }}</label>
                    <input v-model="form.password" type="password" class="login--input"
                           :class="{ 'js-active': form.password !== '' }" :disabled="inputsDisabled" @keydown="inputChange"
                           @keyup.enter.prevent="sendForm">
                </div>
                <div class="login--input--wrap">
                    <label for="" class="login--label">{{ $t('requestResetPasswordPage.form.passwordAgain') }}</label>
                    <input v-model="passwordAgain" type="password" class="login--input"
                           :class="{ 'js-active': passwordAgain !== '' }" :disabled="inputsDisabled" @keydown="inputChange"
                           @keyup.enter.prevent="sendForm">
                </div>
                <div class="login--button--wrap">
                    <button class="login--button" @click.prevent="sendForm">
                        <span class="login--button--text">{{ $t('requestResetPasswordPage.form.submit') }}</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
  import { resetPassword } from '../../api/user';

  export default {
    name: "ResetPasswordPage",
    data: function () {
      return {
        token: null,
        inputsDisabled: false,
        passwordAgain: '',
        form: {
          password: '',
        }
      };
    },
    methods: {
      sendForm: async function () {
        if(this.passwordAgain !== this.form.password){
          this.$toasted.show('Hesla se neshodují.',{type: 'error'});

          this.passwordAgain = '';
          return;
        }
        this.inputsDisabled = true;
        const response = await resetPassword({
          token: this.token,
          newPassword: this.form.password
        });
        this.inputsDisabled = false;

        if(response.data.ok){
          this.$toasted.show('Heslo změněno, Přihlašte se, prosím.',{type: 'success'});
          this.form.email = '';
          this.passwordAgain = '';
          this.$router.push({name: 'Login' });
        }else{
            switch(response.data.message){
              case 'unknown_message':
                this.$toasted.show('Neznámá chyba, zkuste to prosím později.',{type: 'error'});
                break;
              case 'missing_user':
                this.$toasted.show('Neplatný požadavek, heslo již bylo pravděpodobně úspěšně nastaveno.',{type: 'error'});
                break;
            }
        }
      },
      inputChange: function () {

      },
    },
    created: function () {
      this.token = this.$route.params.token;
    }
  }
</script>

<style scoped lang="less">
    .login {
        display: flex;
        min-height: 100vh;
        padding: 30px 10px;
        overflow: hidden;
        margin-bottom: -40vw;
        &--form {
            box-shadow: 0 3.125rem 3.75rem rgba(0, 0, 0, 0.2);
            border-radius: 0.625rem;
            background: #ffffff;
            padding: 25px 25px 30px;
            position: relative;
        }
        &--logo {
            margin: 0 auto 50px;
            mix-blend-mode: multiply;
            position: relative;
        }
        &--content {
            width: 100%;
            max-width: 400px;
            margin: auto;
            position: relative;
        }
        &--input {
            display: flex;
            min-height: 40px;
            width: 100%;
            padding: 8px 12px;
            border: none;
            border-top: solid 2px transparent;
            border-bottom: solid 2px transparent;
            box-shadow: 0 0.063rem 0.188rem rgba(0, 0, 0, 0.2);
            border-radius: 0.25rem;
            background: #ffffff;
            color: #000000;
            font-size: 0.875rem;
            font-weight: 400;
            transition: all 300ms ease;
            &:focus,
            &.js-active {
                outline: none;
                border-radius: 0.25rem 0.25rem 0 0;
                border-bottom-color: #f9a51b;
            }
            &--wrap {
                position: relative;
                margin: 0 0 16px;
            }
        }
        &--label {
            margin: 0 0 4px;
            color: #707070;
            font-size: 0.75rem;
            font-weight: 400;
            transition: all 300ms ease;
        }
        &--button {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 40px;
            min-width: 120px;
            box-shadow: 0 0.063rem 0.188rem rgba(0, 0, 0, 0.2);
            border-radius: 0.25rem;
            background: #f9a51b;
            border: solid 1px #f9a51b;
            color: #ffffff;
            padding: 8px 10px;
            font-size: 1rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 300ms ease;
            &[disabled] {
                box-shadow: 0 0.063rem 0.25rem rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem #ebebf5;
                background: #cacad7;
                border-color: #cacad7;
                cursor: not-allowed;
            }
            &--text {

            }
            &--wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 0 0;
            }
        }
        &--link {
            color: #f9a51b;
            font-size: 0.875rem;
            font-weight: 400;
            text-decoration: underline;
            padding: 10px;
            margin-right: -10px;
        }
        &--error-login {
            position: absolute;
            top: -120px;
            left: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            min-height: 32px;
            padding: 5px 16px;
            box-shadow: 0 1.25rem 3.125rem rgba(214, 7, 79, 0.4);
            border-radius: 0.25rem;
            background: #f12a59;
            color: #ffffff;
            font-size: 0.75rem;
            font-weight: 400;
            &--text {
                max-width: 200px;
            }
            &--icon {
                padding: 5px;
                margin: -5px;
                cursor: pointer;
            }
        }
        &--error {
            font-size: 1rem;
            font-weight: 400;
            color: #ff0000;
            padding: 15px 0 0;
            display: block;
        }
        &--text-wrap {
            padding: 0 10px 20px;
            max-width: 100%;
            text-align: center;
            font-size: 0.875rem;
        }
        @media (max-height: 640px) {
            &--error-login {
                top: 60px;
            }
        }
        @media (max-width: 479px) {
            &--form {
                padding: 15px 15px 20px;
            }
        }
    }
</style>
